module.exports = __webpack_public_path__ + "img/image7.2ae65d50.jpg";